import { chunk } from "../helpers/functions";

function brochuresPage(init, t) {
  const context = {};
  const btnText = $(".btn-more .btn").html();
  let total = 0;
  context.page = 1;
  context.list = new Proxy([], {
    set(array, property, value, receive) {
      context.render([...array]);
      if (array.length >= total) {
        $(".btn-more").hide();
      } else {
        $(".btn-more").show();
      }
      return Reflect.set(...arguments);
    },
  });
  context.start = () => {
    context.page = 1;
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "contents-meta")
        .replace("__PAGE__", 1)
        .replace("__SIZE__", 0),
      dataType: "json",
      success(count) {
        total = parseInt(count);
        if (total <= 0) {
          $(".btn-more").hide();
        }
        context.fetchCategories();
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh."
        );
      },
    });
  };
  context.fetchCategories = () => {
    $.ajax({
      type: "get",
      url: window.toUrl
        .replace("__ACTION__", "contents")
        .replace("__PAGE__", context.page)
        .replace("__SIZE__", 8),
      dataType: "json",
      beforeSend() {
        $(".btn-more .btn").html(
          '<span class="fas fa-spinner fa-spin"></span> Loading...'
        );
      },
      success(response) {
        response.forEach((item) => {
          context.list.push(item);
        });
        context.page++;
      },
      error(xhr, ajaxOptions, thrownError) {
        console.log(
          "There was a problem loading that page. You may need to refresh."
        );
      },
      complete() {
        $(".btn-more .btn").html(btnText);
      },
    });
  };
  context.render = (list) => {
    if (list.length > 0) {
      const chunks = chunk(list, 4);
      const t = `
            ${chunks
              .map(
                (chunk) => `
                <div class="row">
                    ${chunk
                      .map(
                        (content) => `
                        <div class="col-md-3">
                        ${context.contentTemplate(content)}
                        </div>
                    `
                      )
                      .join("")}
                </div>
            `
              )
              .join("")}
        `;
      $(".posts").html(t);
    } else {
      $(".posts").empty();
    }
  };

  context.contentTemplate = (content) => {
    return `
        <div class="item" style="--image:url('${
          content.brochure_image?.url || null
        }');">
            <div class="info">
                <h2 class="title">${content.local.title}</h2>
                <a href="${
                  content.local.brochure_pdf ? content.local?.brochure_pdf[0]?.url : '#'
                }" target="_blank" class="pdf">
                <span class="fas fa-arrow-circle-down"></span>
                ${t["Download PDF"] || "Download PDF"}
                </a>
            </div>
        </div>
    `;
  };

  $(".btn-more").on("click", context.fetchCategories);

  init(context);
}

window.brochuresPage = brochuresPage;
